import React from "react";
import {
  DollarOutlined,
  PieChartOutlined,
  ThunderboltOutlined,
  TrophyOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import "../../crmSharedStyle.css";

const DealsDashboard = ({ authInfo, deals }) => {
  const currency = authInfo?.currency || "";
  const total = deals.reduce((sum, d) => sum + Number(d.value || 0), 0);

  const won = deals.filter((d) => d.stage === "won").length;
  const lost = deals.filter((d) => d.stage === "lost").length;
  const active = deals.length - won - lost;

  const stageProbability = {
    prospecting: 0.1,
    negotiation: 0.5,
    won: 1,
    lost: 0,
  };

  const weightedTotal = deals.reduce((sum, d) => {
    const prob = stageProbability[d.stage] || 0;
    return sum + Number(d.value || 0) * prob;
  }, 0);

  const tiles = [
    {
      key: "total",
      label: "Total Pipeline",
      icon: <DollarOutlined />,
      value: `${currency} ${total.toLocaleString()}`,
      accent: "#1677ff",
    },
    {
      key: "weighted",
      label: "Weighted Pipeline",
      icon: <PieChartOutlined />,
      value: `${currency} ${Math.round(weightedTotal).toLocaleString()}`,
      accent: "#722ed1",
    },
    {
      key: "active",
      label: "Active Deals",
      icon: <ThunderboltOutlined />,
      value: active,
      accent: "#fa8c16",
    },
    {
      key: "won",
      label: "Won",
      icon: <TrophyOutlined />,
      value: won,
      accent: "#52c41a",
    },
    {
      key: "lost",
      label: "Lost",
      icon: <CloseCircleOutlined />,
      value: lost,
      accent: "#f5222d",
    },
  ];

  return (
    <div className="crm-stat-row">
      {tiles.map((t) => (
        <div key={t.key} className="crm-stat-tile accent" style={{ "--tile-accent": t.accent }}>
          <div className="crm-stat-tile-label">
            {t.icon}
            {t.label}
          </div>
          <div className="crm-stat-tile-value">{t.value}</div>
        </div>
      ))}
    </div>
  );
};

export default DealsDashboard;
